import React, { useEffect, useState } from "react";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import certificatesIcon from "../../../assets/images/profile/icon-hat.png";
import courseCompletedIcon from "../../../assets/images/profile/icon-doc-check.png";
import documentsIcon from "../../../assets/images/profile/icon-docus.png";
import axios from "axios";
import { useSelector } from "react-redux";
import ProfileHeader from "../../afterLogin/student-dashboard/settings/PofileHeader";
import CertificatesCarousel from "./CertificatesCarousel";
import CoursesApprenticeshipTabs from "./CoursesApprenticeshipTabs";
import LearnerAchievements from "./LearnerAchievements";
import ExternalCertificates from "./ExternalCertificates";
import Error404 from "../../../modules/Error404";

let host = window.location.protocol + "//" + window.location.host;

const Profile = ({ public_id }) => {
  const [hasError, setHasError] = useState(false);
  const [learnerData, setLearnerData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const configData = useSelector((state) => state.config);
  const setting = useSelector((state) => state.setting);
  const bannerImgPath = 'https://d2cl07xv2ii8xi.cloudfront.net/uploads/miscellaneous/profile-banner.webp';
  const getLearnerDetails = async () => {
    try {
      let data = JSON.stringify({
        public_id: public_id,
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${host}/api/front_end/get_learner_detail`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      const response = await axios.request(config);
      setLearnerData(response?.data?.result);
      if (
        response?.data?.result?.has_public_profile == '0' &&
        configData?.session &&
        Object.keys(configData?.session).length === 0
      ) {
        setHasError(true);
      }
    } catch (err) {
      console.log(err.message);
    } finally {
      // Update loading state
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getLearnerDetails();
  }, []);

  const achievements = [
    {
      title: "Certificate Achieve",
      count: setting.certificatecount,
      icon: certificatesIcon,
    },
    {
      title: "Course Completed",
      count: setting.coursecount,
      icon: courseCompletedIcon,
    },
    {
      title: "Program Completed",
      count: setting.programcount,
      icon: certificatesIcon,
    },
    {
      title: "External Certificates & Documents",
      count: setting.externaldoccount,
      icon: documentsIcon,
    },
  ];

  if (isLoading) {
    return <div>loading...</div>;
  }

  //Address
  const addressObject = JSON.parse(learnerData?.address);
  const address =
    !addressObject || typeof addressObject !== "object"
      ? "N/A"
      : Object.values(addressObject).join(", ");

  function maskStringAfterPosition(str, position, maskChar = "*") {
    return str.slice(0, position) + str.slice(position).replace(/./g, maskChar);
  }

  const maskedAddress = maskStringAfterPosition(address, 4);

  let avatar;
  if (learnerData.avatar === "default.jpg") {
    avatar = `${configData.s3_url}uploads/default/user/${learnerData.avatar}`;
  } else {
    avatar = `${configData.s3_url}uploads/${window.location.host}/items_org/user/${learnerData.avatar}`;
  }

  let publicBannerImage;
  if(learnerData?.banner_image === "default-banner.jpg") {
    publicBannerImage = `${bannerImgPath}`;
  } else {
    publicBannerImage = `${configData.s3_url}uploads/${window.location.host}/items_org/user/banner/${learnerData?.banner_image}`;
  }

  if (hasError) return <Error404 />; 

  return (
    <div className="px-0 pt-0">
      <Row>
        <Col lg={12}>
          <ProfileHeader
            className="myk__stu-public-profile mb-0"
            publicProfileImage={avatar}
            defaultProfileImg={avatar}
            name={learnerData.full_name}
            email={learnerData.email_address}
            phone={`${learnerData.country_code} ${learnerData.phone}`}
            location={maskedAddress}
            dropdownDownloadItems={true}
            dotDropdownItems={true}
            publicProfile={true}
            publicProfileBannerImgUrl={publicBannerImage}
          />
        </Col>
      </Row>

      <div className="myk__stu-setting-body-wrapper">
        <Row>
          <Col xl="6">
            <CertificatesCarousel public_id={public_id} />
            <CoursesApprenticeshipTabs setHasError={setHasError} public_id={public_id} products={learnerData.products} spUserAccessMap={learnerData.user_sp_access} />
          </Col>
          <Col xl="6">
            <LearnerAchievements
              public_id={public_id}
              achievements={achievements}
              products={learnerData.products} 
              spUserAccessMap={learnerData.user_sp_access}
            />
            <ExternalCertificates public_id={public_id} hasCertificateDocument={learnerData.has_certificate_document} />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Profile;
